import api from "./apiBase";

function getStores({ page, limit, name }) {
  const query = new URLSearchParams();
  query.append("page", page);
  query.append("limit", limit);
  if (name) query.append("name", name);
  return api.get(`/stores?${query.toString()}`);
}

function addStore(data) {
  return api.post("/stores", data);
}

function findStoreById(id) {
  return api.get("/stores/" + id);
}

function updateStore(id, data) {
  return api.patch("/stores/" + id, data, {
    headers: { "Content-Type": "application/json" },
  });
}

function removeStore(id) {
  return api.delete("/stores/" + id);
}

export {
  getStores,
  addStore,
  findStoreById,
  updateStore,
  removeStore,
}
